<template>
    <v-card>
      <v-card-title class="title">
        <v-icon class="mr-2">link</v-icon>
        <div>Services Refresh Tokens</div>
      </v-card-title>
      <v-card-text>
        <div>
          Service Refresh Tokens are used by service registry to acquire access token to access the system.
        </div>
        <div>
          <v-autocomplete class="rounded" solo :items="tenants" v-model="selectedTenant" :label="tenants.length > 0 ? 'Select a tenant' : 'No tenants'" clearable single-line item-text="RoleName" item-value="Id" return-object persistent-hint>
          </v-autocomplete>
        </div>
        <div v-if="selectedTenant && checkingResult.Valid">
          <v-icon class="mr-1" :color="'primary'" v-html="'done'" /> Tenant {{ selectedTenant.RoleName }} contains valid service refresh token already.
          <v-btn @click.native="generateServiceRefreshToken(true)">
            <v-icon left>refresh</v-icon>
            Regenerate service refresh token</v-btn>
        </div>
        <div v-if="selectedTenant && !checkingResult.Valid">
          <v-icon class="mr-1" :color="'error'" v-html="'clear'" /> Tenant {{ selectedTenant.RoleName }} does not contain valid service refresh token yet.
          <v-btn color="warning" @click.native="generateServiceRefreshToken(false)" :loading="loading">
            <v-icon left>add</v-icon>
            Generate service refresh token</v-btn>
        </div>
        <!-- 
        <v-chip v-for="(link, index) in serviceLinks" :key="`missing-link-${index}`" small>
          <v-icon class="mr-1" :color="link.ServiceId ? 'success' : 'error'" v-html="link.ServiceId ? 'done' : 'clear'" />
          {{ splitCapitalizeByChar(link.ServiceLink, '_') }}
        </v-chip> -->
      </v-card-text>
    </v-card>
  </template>

<script>
import {
  splitCapitalizeByChar,
} from '@/helpers/strings'

import { createNamespacedHelpers } from 'vuex'
const app = createNamespacedHelpers('app')
const servicerefreshtokens = createNamespacedHelpers('servicerefreshtokens')
const authenticate = createNamespacedHelpers('authenticate')
const admin = createNamespacedHelpers('admin')

export default {
  props: {
  },
  data: () => ({
    loading: false,
    selectedTenant: null,
    checkingResult: null,
  }),
  computed: {
    ...authenticate.mapGetters(['currentTenant']),
    ...admin.mapGetters(['tenants']),
  },
  watch: {    
    selectedTenant() {      
      if(this.selectedTenant != null){        
        this.checkTenantServiceToken()
      }
    },
  },
  methods: {
    ...servicerefreshtokens.mapActions(['checkTenantServiceRefreshToken', 'generateTenantServiceRefreshToken']),
    ...app.mapActions(['setSnackbar']),
    splitCapitalizeByChar,
    async checkTenantServiceToken() {
      this.loading = true
      try {
        var result = await this.checkTenantServiceRefreshToken({tenantName: this.selectedTenant.RoleName})
        
        this.checkingResult = result
        this.loading = false
      } catch (error) {        
        this.setSnackbar({
          text: 'Fail to check service refresh token for tenant ' + this.selectedTenant.RoleName + ' . Please contact Hatfield on this issue.',
          color: 'error',
          icon: 'error',
        })
        this.loading = false
      }
    },
    async generateServiceRefreshToken(isRegenerate) {
      console.log('generate refresh token...')
      this.loading = true
      var that = this
      try {
        var result = await this.generateTenantServiceRefreshToken({TenantName: this.selectedTenant.RoleName, IsRegenerate: isRegenerate})
        
        this.checkingResult = result
        this.loading = false

        that.checkTenantServiceToken()
      } catch (error) {        
        this.setSnackbar({
          text: 'Fail to generate service refresh token for tenant ' + this.selectedTenant.RoleName + ' . Please contact Hatfield on this issue.',
          color: 'error',
          icon: 'error',
        })
        this.loading = false
      }
    },
  },  
  mounted() {        
  },
}
</script>